export var ReplaceMode;
(function (ReplaceMode) {
    ReplaceMode["current"] = "current";
    ReplaceMode["everywhere"] = "everywhere";
})(ReplaceMode || (ReplaceMode = {}));
